import { render, staticRenderFns } from "./ProjectPayments.vue?vue&type=template&id=d432757a&"
import script from "./ProjectPayments.vue?vue&type=script&lang=js&"
export * from "./ProjectPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports